import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

class Accordion {
  constructor(el) {
    this.el = el
    this.panel = el.getElementsByClassName('area-hidden')[0]
    this.button = el.getElementsByClassName('menu-price__button')[0]
    this.triangle = this.button.getElementsByClassName('triangle')[0]
    this.state = false

    this.button.addEventListener('click', (e) => {
      const panelHeight = e.currentTarget.getAttribute('data-panel')
      if (panelHeight === 'low') {
        this.state ? this.closeShort() : this.openShort()
      } else {
        this.state ? this.close() : this.open()
      }
    })
  }

  open() {
    gsap.to(this.panel, {
      duration: 1.5,
      ease: 'quart.out',
      height: 'auto',
      onComplete: () => ScrollTrigger.refresh(),
    })

    gsap.to(this.triangle, {
      clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
      duration: 1.5,
    })

    this.state = true
  }

  openShort() {
    gsap.to(this.panel, {
      ease: 'quart.out',
      height: 'auto',
      onComplete: () => ScrollTrigger.refresh(),
    })

    gsap.to(this.triangle, {
      clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    })

    this.state = true
  }

  close() {
    gsap.to(this.panel, {
      height: 0,
      duration: 1.5,
      onComplete: () => ScrollTrigger.refresh(),
    })

    gsap.to(this.triangle, {
      clipPath: 'polygon(50% 100%, 0% 0%, 100% 0%)',
      duration: 1.5,
    })

    this.state = false
  }

  closeShort() {
    gsap.to(this.panel, {
      height: 0,
      onComplete: () => ScrollTrigger.refresh(),
    })

    gsap.to(this.triangle, {
      clipPath: 'polygon(50% 100%, 0% 0%, 100% 0%)',
    })

    this.state = false
  }
}

export default Accordion
